export default "__VITE_ASSET__b9481c55__"